import { render, staticRenderFns } from "./CasesDetail.vue?vue&type=template&id=dacd77cc&scoped=true"
import script from "./CasesDetail.vue?vue&type=script&lang=js"
export * from "./CasesDetail.vue?vue&type=script&lang=js"
import style0 from "./CasesDetail.vue?vue&type=style&index=0&id=dacd77cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacd77cc",
  null
  
)

export default component.exports